import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { tabsItem, tabsItemHorizontalGap } from './item.vanilla.mjs';
import { TabsItemSlot } from './ItemSlot.mjs';

const TabsItem = forwardRef(
  ({
    children,
    className: classNameFromProps,
    leftSlot,
    rightSlot,
    space,
    style: styleFromProps,
    ...props
  }, forwardedRef) => {
    const className = classNames(tabsItem, classNameFromProps);
    const styles = Object.assign(
      {},
      assignInlineVars({
        [tabsItemHorizontalGap]: space !== void 0 ? `${space}px` : null
      }),
      styleFromProps
    );
    const content = isNil(leftSlot) && isNil(rightSlot) ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(TabsItemSlot, { children: leftSlot }),
      children,
      /* @__PURE__ */ jsx(TabsItemSlot, { children: rightSlot })
    ] });
    return /* @__PURE__ */ jsx(
      TabsPrimitive.Trigger,
      {
        "data-scope": "tabs",
        "data-part": "item",
        className,
        style: styles,
        ref: forwardedRef,
        ...props,
        children: content
      }
    );
  }
);
TabsItem.displayName = "Tabs.Item";

export { TabsItem };
//# sourceMappingURL=Item.mjs.map
